import { ICellRendererParams } from 'ag-grid-community'
import { StatusChip } from '.'

/**
 * ステータス列用の AG Grid セルレンダラ。
 * params.value（ステータス文字列）をプロジェクト計画と同じセレクトボックス風の
 * チップで表示する（表示専用・編集不可のためシェブロンは表示しない）。
 *
 * sevend-ag-cell クラスで他のセルと同じ左右余白・縦中央寄せ・はみ出し制御に揃える。
 */
export const StatusChipCellRenderer = (params: ICellRendererParams) => {
  const status = params.value as string | null | undefined
  if (!status) return null
  return (
    <div className="sevend-ag-cell">
      <StatusChip status={status} />
    </div>
  )
}
